import { CheckCircle as CheckCircleIcon, Save as SaveIcon } from '@mui/icons-material';
import { Box, CircularProgress, Stack } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledButton } from '../styles/StyledButtons';
import { StyledCard, StyledCardContent, StyledTypography } from '../styles/styles';

interface ReviewViewerSaveChangesCardProps {
  tone: keyof typeof Palette;
  savingDraft: boolean;
  onSave: () => void;
}

export default function ReviewViewerSaveChangesCard({
  tone,
  savingDraft,
  onSave,
}: ReviewViewerSaveChangesCardProps) {
  return (
    <StyledCard tone={tone} sx={{ mt: 3 }}>
      <StyledCardContent>
        <Stack direction="row" alignItems="center" spacing={2}>
          <CheckCircleIcon color="success" />
          <Box sx={{ flex: 1 }}>
            <StyledTypography tone={tone} variant="h6">
              Accepted Changes Ready
            </StyledTypography>
            <StyledTypography tone={tone} variant="body2" color="text.secondary">
              You have accepted changes that can be saved to the draft version.
            </StyledTypography>
          </Box>
          <StyledButton
            variant="contained"
            color="success"
            onClick={onSave}
            disabled={savingDraft}
            startIcon={savingDraft ? <CircularProgress size={20} /> : <SaveIcon />}
          >
            {savingDraft ? 'Saving...' : 'Save Accepted Changes to Draft'}
          </StyledButton>
        </Stack>
      </StyledCardContent>
    </StyledCard>
  );
}
